module.exports = __webpack_public_path__ + "images/psp/MilitaryIcons/MilitarySizeChartTwo/iconSix.svg";